<template>
    <div class="page">
        <div class="header">
            <Header :current="['fw']"></Header>
            <div class="zt-title">订单农业发布</div>
        </div>
        <div class="page-content">
            <div class="page-form">
                <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules" ref="formRef">
                    <a-form-item label="订单名称" name="title">
                        <a-input v-model:value="formState.title"  placeholder="例：花生"/>
                    </a-form-item>
                    <a-form-item label="订单价格" name="price">
                        <a-input-number v-model:value="formState.price" placeholder="价格"/>
                        <!-- <a-select v-model:value="formState.company" placeholder="价格" style="width: 100px;margin-left: 5px">
                            <a-select-option v-for="(item, i) in subjectData.priceList" :value="item.name" :key="i">{{ item.value }}</a-select-option>
                        </a-select> -->
                    </a-form-item>
                    <a-form-item label="订单单位" name="company">
                        <a-select v-model:value="formState.company" placeholder="价格">
                            <a-select-option v-for="(item, i) in subjectData.priceList" :value="item.name" :key="i">{{ item.value }}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="订单类型" name="type">
                        <a-select v-model:value="formState.type" placeholder="请选择分类">
                            <a-select-option v-for="(item, i) in subjectData.serviceList" :value="item.name" :key="i">{{ item.value }}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="订单数量" name="count">
                        <a-input-number v-model:value="formState.count" placeholder="数量"/>
                    </a-form-item>
                    <a-form-item label="开始时间" required name="effectiveTime">
                        <a-date-picker
                            v-model:value="formState.effectiveTime"
                            show-time
                            type="date"
                            placeholder="开始时间"
                            style="width: 100%"
                        />
                    </a-form-item>
                    <a-form-item label="结束时间" required name="failureTime">
                        <a-date-picker
                            v-model:value="formState.failureTime"
                            show-time
                            type="date"
                            placeholder="结束时间"
                            style="width: 100%"
                        />
                    </a-form-item>
                    <a-form-item label="所在镇街" name="towns">
                        <a-select v-model:value="formState.towns" placeholder="请选择所在镇街">
                            <a-select-option v-for="(item, i) in this.$utils.townList" :value="item.id" :key="i">{{ item.name }}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="服务范围" name="address">
                        <a-input v-model:value="formState.address" placeholder="请输入服务区域"/>
                    </a-form-item>
                    <a-form-item label="服务主体" name="publisher">
                        <a-input v-model:value="formState.publisher" placeholder="输入发布人姓名"/>
                    </a-form-item>
                    <a-form-item label="联系电话" name="phone">
                        <a-input v-model:value="formState.phone" placeholder="请输入联系电话"/>
                    </a-form-item>
                    <a-form-item label="服务图片" name="imgs">
                        <a-upload
                            action="http://up-z1.qiniup.com"
                            list-type="picture-card"
                            v-model:file-list="fileList2"
                            accept="image/*"
                            :data="{token:subjectData.token}"
                            @change="handleChange2"
                            :multiple=true
                        >
                            <div v-if="fileList2.length < 9">
                                <plus-outlined />
                                <div class="ant-upload-text">上传</div>
                            </div>
                        </a-upload>
                    </a-form-item>
                    <a-form-item label="服务内容" name="msg">
                        <a-input v-model:value="formState.msg" type="textarea"  placeholder="请输入需求内容"/>
                    </a-form-item>
                    <a-form-item :wrapper-col="{ span: 24, offset: 5 }">
                        <a-button type="primary" @click="onSubmit" size="large" class="cus-button">发布</a-button>
                    </a-form-item>
                </a-form>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/portal/Header'
import Footer from "../../components/portal/Footer"
import {useRouter} from "vue-router"
import { defineComponent, reactive, toRaw } from 'vue'
import {onMounted, ref} from "@vue/runtime-dom"
import {getQiNiuToken} from "@/api/directories"
import { getPriceCompanyType } from "@/api/service"
import {notification} from "ant-design-vue"
import { PlusOutlined } from '@ant-design/icons-vue'
import {getOrderType, saveOrderApi} from "@/api/order"
import Cookies from "js-cookie"
export default defineComponent ({
    name: "InformationServiceAdd",
    setup() {
        const create = Cookies.get('userInfo') ? JSON.parse(Cookies.get('userInfo')).userId : null
        const formState = reactive({
            title: '',
            price: '',
            company: '',
            type: undefined,
            varieties: undefined,
            effectiveTime: undefined,
            failureTime: undefined,
            towns: undefined,
            address: undefined,
            publisher: undefined,
            phone: undefined,
            imgs: undefined,
            msg: undefined,
            count: undefined,
        })
        const subjectData = reactive({
            priceList: [],
            serviceList: [],
            token: ''
        })
        const formRef = ref()
        const getServiceInfo = async () => {
            const serviceRes = await getOrderType()
            const list0 = []
            for (const n in serviceRes) {
                list0.push({name: n, value: serviceRes[n]})
            }
            subjectData.serviceList = list0
            const priceRes = await getPriceCompanyType()
            const list1 = []
            for (const n in priceRes) {
                list1.push({name: n, value: priceRes[n]})
            }
            subjectData.priceList = list1
        }
        const fileList2 = ref([])
        const handleChange2 = ({ fileList: newFileList }) => {
            fileList2.value = newFileList
        }
        const getToken = async () => {
            // 获取七牛token
            const token = await getQiNiuToken()
            subjectData.token = token
        }
        const router = useRouter()
        const tabs = [
            {title: '需求信息发布', isActive: false},
            {title: '服务信息发布', isActive: true}
        ]
        const tabsClick = (i) => {
            if (i == 0) {
                router.push({ name: 'DemandInformationAdd'})
            }
        }
        const rules = {
            title: [{required: true, message: '请输入服务名称', trigger: 'blur'}],
            price: [{required: true, message: '请输入价格', trigger: 'blur', type: 'number'}],
            company: [{required: true, message: '请选择单位', trigger: 'change'}],
            type: [{required: true, message: '请输入服务类型', trigger: 'blur'}],
            count: [{required: true, message: '请输入', trigger: 'blur', type: 'number'}],
            varieties: [{required: true, message: '请输入服务品种', trigger: 'blur'}],
            effectiveTime: [{ required: true, message: '请选择开始时间', trigger: 'change', type: 'object' }],
            failureTime: [{ required: true, message: '请选择结束时间', trigger: 'change', type: 'object' }],
            towns: [{required: true, message: '请选择所在镇街', trigger: 'blur'}],
            address: [{required: true, message: '请输入地址', trigger: 'blur'}],
            publisher: [{required: true, message: '请输入发布人', trigger: 'blur'}],
            phone: [{required: true, message: '请输入联系电话', trigger: 'blur'}],
            imgs: [{required: false, message: '请选择', type: 'any'}],
            msg: [{required: true, message: '请输入服务内容', trigger: 'blur'}],
        }
        const onSubmit = async() => {
            formRef.value
                .validate()
                .then(() => {
                    let subjectImgs
                    if (fileList2.value.length > 0) {
                        const fileList2List = []
                        for (const i in fileList2.value) {
                            fileList2List.push(fileList2.value[i].response.key)
                        }
                        subjectImgs = fileList2List.toString() // 主体图片列表
                    } else {
                        notification.warning({ message: '错误！', duration: 2.5, description: '请至少选择一张服务图片' })
                        return
                    }
                    const value = toRaw(formState)
                    console.log(value)
                    const params = {
                        title: value.title,
                        price: value.price,
                        company: value.company,
                        type: value.type,
                        effectiveTime: value.effectiveTime.format('YYYY-MM-DD'),
                        failureTime: value.failureTime.format('YYYY-MM-DD'),
                        towns: value.towns,
                        address: value.address,
                        publisher: value.publisher,
                        phone: value.phone,
                        imgs: subjectImgs,
                        msg: value.msg,
                        count: value.count,
                        creater: create
                    }
                    saveOrderApi(params).then(data => {
                        if (data) {
                            notification.success({ message: '提交成功！', duration: 2.5, description: '' })
                            setTimeout(() => {
                                location.reload()
                            }, 2000)
                        }
                        })
                    })
                .catch(error => {
                    console.log('error', error);
                })
        }
        onMounted(() => {
            getToken()
            getServiceInfo()
        })
        return {
            tabs,
            tabsClick,
            labelCol: {
                span: 4,
            },
            wrapperCol: {
                span: 16,
                offset: 2
            },
            formState,
            fileList2,
            subjectData,
            rules,
            onSubmit,
            handleChange2,
            formRef
        }
    },
    components: {
        Header,
        Footer,
        PlusOutlined
    }
})
</script>

<style scoped lang="stylus">
.page {
    width 100%
    height 100%
    position relative
    font-size 16px
    background-color #FFF
    .header {
        width 100%
        height 730px
        padding-top 130px
        box-shadow 0 23px 120px rgba(0, 0, 0, 0.3)
        border-bottom-left-radius 315px
        border-bottom-right-radius 315px
        background-image url("../../assets/img/portal_service_bg.png")
        background-size 100% 100%
        background-repeat no-repeat
        z-index 1
        position relative
        .zt-title {
            margin-top 200px
            width 100%
            font-size 48px
            color #FFF
            font-weight bold
            text-align center
        }
    }
    .page-content {
        width 100%
        min-height 200px
        margin-top 80px
        padding 50px 20px
        .page-form {
            width 100%
            padding 30px
            background #FFF
        }
        .cus-button {
            width 50%
            height 50px
            line-height 50px
        }
    }
}
</style>